import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { catchError, finalize, tap } from "rxjs/operators";
import { of } from "rxjs";
import { ServerTokenService } from "../../services/server-token.service";
import { EhrSourceRegion } from "./ehr-sources-settings.interface";

@Component({
  selector: 'ehr-sources-settings',
  templateUrl: './ehr-sources-settings.component.html',
  styleUrls: ['./ehr-sources-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EhrSourcesSettingsComponent implements OnInit {

  ehrSources: EhrSourceRegion[] = [];

  loading = false;

  constructor(
    private server: ServerTokenService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadEhrSources();
  }

  onEhrSourceToggle(source: EhrSourceRegion, assigned: boolean): void {
    this.server.postWithToken<{ ok: boolean }>('snfs/admin/updateEhrSettingRegion', {
      ehrSettingId: source._id,
      assigned,
    }).pipe(
      tap(() => {
        source.assignedToRegion = assigned;
        this.cdr.markForCheck();
      }),
      catchError(error => {
        console.error(error);
        return of(null);
      }),
    ).subscribe();
  }

  onSelectAll(assigned: boolean): void {
    this.ehrSources.forEach(source => this.onEhrSourceToggle(source, assigned));
  }

  get allSelected(): boolean {
    return this.ehrSources.length > 0 && this.ehrSources.every(s => s.assignedToRegion);
  }

  private loadEhrSources(): void {
    this.loading = true;
    this.server.getWithToken<EhrSourceRegion[]>('snfs/admin/getEhrSettings').pipe(
      tap(ehrSources => {
        this.ehrSources = ehrSources;
      }),
      catchError(error => {
        console.error(error);
        return of(null);
      }),
      finalize(() => {
        this.loading = false;
        this.cdr.markForCheck();
      }),
    ).subscribe();
  }
}
